import { Component, OnDestroy, OnInit, Input, EventEmitter, Output } from '@angular/core';
import { HhsgSharedClientApplication } from '../../../models/client-application.model';
import { HhsgSharedClient } from '../../../models/client.model';
import { HhsgSharedStuderDepartment } from '../../../models/sgportal-data-api-models/department.model';
import { HhsgSharedStuderOrganization } from '../../../models/sgportal-data-api-models/organization.model';
import { HhsgSharedStuderState } from '../../../models/sgportal-data-api-models/state.model';
import { HhsgSharedApplicationsService, HhsgSharedStuderOrganizationService } from '../../../services';
import { HhsgSharedStuderDepartmentService } from '../../../services/studer/department.service';
import { HhsgSharedStuderDivisionService } from '../../../services/studer/division.service';
import { HhsgSharedStuderFacilityService } from '../../../services/studer/facility.service';
import { HhsgSharedStuderJobTitleService } from '../../../services/studer/job-title.service';

@Component({
	selector: 'show-studer-organization',
	templateUrl: 'organization.component.html',
	styleUrls: ['organization.component.scss']
})
export class HhsgSharedStuderOrganizationComponent implements OnInit, OnDestroy {

	constructor
	(
		private _applicationsService: HhsgSharedApplicationsService,
		private _organizationService: HhsgSharedStuderOrganizationService,
		private _departmentService: HhsgSharedStuderDepartmentService,
		private _divisionService: HhsgSharedStuderDivisionService,
		private _jobTitleService: HhsgSharedStuderJobTitleService,
		private _facilityService: HhsgSharedStuderFacilityService
	) { }

	isLoading: boolean = false;
	isAdding: boolean = false;
	isEditing: boolean = false;
	confirmDelete: boolean = false;
	showMinFields: boolean = true;
	errorMessage: string = '';
	clients: HhsgSharedClient[];
	states: HhsgSharedStuderState[];

	selectedClient: HhsgSharedClient;
	IsVMorLEMSelected: boolean;
	
	clientId: number;
	organization: HhsgSharedStuderOrganization = new HhsgSharedStuderOrganization();
	selectedOrganization: HhsgSharedStuderOrganization;
	childApplicationClientId: number;
	
	deptsWithEmployeeCount: HhsgSharedStuderDepartment[];
	departmentCount: number;
	divisionCount: number;
	facilityCount: number;
	jobTitleCount: number;

	async ngOnInit(): Promise<void> {
	}	

	@Input('currentClient') set currentClient(client: HhsgSharedClient) {
		this.selectedClient = client;
		this.onSelectedClientChanged(client);
	}
	@Output() isEdited = new EventEmitter<boolean>();
	
	async onSelectedClientChanged(client: HhsgSharedClient): Promise<void> {
			if (!client || !client.id) {			
			this.organization = new HhsgSharedStuderOrganization();
			this.selectedOrganization = new HhsgSharedStuderOrganization();
			this._organizationService.currentOrganization = new HhsgSharedStuderOrganization();
			return;
		}
		this.isLoading = true;
		this.clientId = client.id;
		if (this.showMinFields  || (this.states && this.states.length > 0)) {
			 await this.getOrganization(client);
		} else {
		this._organizationService.getStates().then( async (result) => {
			this.states = result;			
			 await this.getOrganization(client);
			});
		}
	}

	getOrganization(client: HhsgSharedClient) {
		this.organization = new HhsgSharedStuderOrganization();
		this.selectedOrganization = new HhsgSharedStuderOrganization();
		this._organizationService.currentOrganization = new HhsgSharedStuderOrganization();
		let studerApp: HhsgSharedClientApplication = client.clientApplicationModels.find(ca => (ca.applicationName.toUpperCase() === "STUDER GROUP PORTAL" || 
			ca.applicationName.toUpperCase() === "PATIENT CALL MANAGER" || 
			ca.applicationName.toUpperCase() === "LEADER EVALUATION MANAGER" || 
			ca.applicationName.toUpperCase() === "VALIDATION MATRIX") && ca.childApplicationClientId > 0);
		if (studerApp) {
			this.childApplicationClientId = studerApp.childApplicationClientId;
				this._organizationService.getOrganization(this.childApplicationClientId).then((result) => {
					this.organization = result;
					this.selectedOrganization = result;
					this._organizationService.currentOrganization = result;
					this.getCountsForOrg();
					this.isLoading = false;
				});				
		} else {
			this.isLoading = false;
		}		
	}

	async getOrganizationById(orgId: number) {
		this.organization = new HhsgSharedStuderOrganization();
		this.selectedOrganization = new HhsgSharedStuderOrganization();
		this._organizationService.currentOrganization = new HhsgSharedStuderOrganization();
		await this._organizationService.getOrganization(orgId).then((result) => {
						this.organization = result;
						this.selectedOrganization = result;
						this._organizationService.currentOrganization = result;
						this.isLoading = false;
					});				
			this.isLoading = false;	
	}

	showEditError(editInput: HTMLInputElement): boolean {
		try {
		return !editInput.validity.valid;
		} catch {
			alert(editInput.name);
		}
	}

	greaterThanMinus1(id: number): boolean {
		return (id > -1);
	}

	async getCountsForOrg() {
		this.deptsWithEmployeeCount = null;
		await this._applicationsService.getClientApplications(this.clientId).then((result) => {
			let studerApp = result.find(ca => ca.applicationAbbreviation === 'SgPortal' || ca.applicationAbbreviation === 'PCM' || ca.applicationAbbreviation === 'LEM' || ca.applicationAbbreviation === 'VM');
			if (studerApp) {
				this.childApplicationClientId = studerApp.childApplicationClientId;
					this._departmentService.getActiveDepartmentsWithEmployeeCount(this.childApplicationClientId).then(async (result) => {
						this.deptsWithEmployeeCount = result;
						this._departmentService.departmentCount = this.deptsWithEmployeeCount.length;
						this.departmentCount = this.deptsWithEmployeeCount.length;
						var jobs = await this._jobTitleService.getJobTitlesWithEmployeeAndDeptCount(this.childApplicationClientId);
						this.jobTitleCount = jobs.length;
						var divs = await this._divisionService.getDivisionsWithEmployeeCount(this.childApplicationClientId);
						this.divisionCount = divs.length;
						var facs = await this._facilityService.getOrganizationFacilities(this.childApplicationClientId);
						this.facilityCount = facs.length;						
						this.isLoading = false;
					});				
			} else {
				this.isLoading = false;
			}
		});
	}

	onClickEdit(organization: HhsgSharedStuderOrganization) {
		this.selectedOrganization = organization;
		this.isEditing = true;
		return false;
	}

	onClickAddNew(organization: HhsgSharedStuderOrganization) {
		this.selectedOrganization = organization;
		this.isAdding = true;
		return false;
	}

	onCloseEdit() {
		this.isAdding = false;
		this.isEditing = false;
		this.confirmDelete = false;
		this.getOrganizationById(this.selectedOrganization.id);
	}

	confirmDeleteFacility(organization: HhsgSharedStuderOrganization) {
		this.selectedOrganization = organization;
		this.confirmDelete = true;
	}

	deleteOrganization() {
		this._organizationService.deleteOrganization(this.selectedOrganization).then(() => {
			this.confirmDelete = false;
		});
	}

	onEdited($event): void {
		if ($event) {
			this.isEdited.emit(true);
		}
	} 

	ngOnDestroy(): void {
		this.isEdited.unsubscribe();
	}
 }
